export default {"src":"/_next/static/media/bharatpe.6c451cbb.svg","height":277,"width":1514,"blurWidth":0,"blurHeight":0};